'use client';

import type { UserType } from '@/types';

import React from 'react';
import { usePathname } from 'next/navigation';

import { Button, Container, Image, Link, Text, VStack } from '@/components';
import { useTranslation } from '@/hooks';
import LoginFirstImage from '@/images/checkout/loginFirst.png';
import { routes } from '@/statics';

const FirstLogin: React.FC<{
  profileType?: UserType | undefined;
  onlyAgent: boolean;
}> = ({ profileType, onlyAgent }) => {
  const { t } = useTranslation('pages.categories');
  const pathname = usePathname();
  return (
    <VStack gap={16} mb={{ base: '100px', md: '140px' }}>
      <Image src={LoginFirstImage} alt="login first" />
      <Container>
        <Text
          textAlign="center"
          fontSize={{ base: 'lg', md: 'xl' }}
          fontWeight="bold"
        >
          {t.rich('firstBeAgent', { br: () => <br /> })}
        </Text>
      </Container>
      {onlyAgent && profileType === 'customer' ? (
        <Button as={Link} size="lg" href={routes.identityBecomeAgent.url}>
          {t('becomeAgent')}
        </Button>
      ) : (
        <Button
          as={Link}
          href={`${routes.signIn.url}?returnURL=${pathname}`}
          w={{ base: '80vw', md: 'unset' }}
          colorScheme="primary"
          size="lg"
        >
          {t('signUpSignIn')}
        </Button>
      )}
    </VStack>
  );
};

export default FirstLogin;
